<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row>
    <v-col cols="12">
      <v-btn @click="blocked=false; promocodeDialog = true">Подарить промокод</v-btn>
      <v-btn class="ml-2" @click="blocked=true; promocodeDialog = true">Заблокировать промокод</v-btn>
    </v-col>
    <v-col cols="12" sm="12">
      <v-data-table
              no-data-text="Нет промокодов"
              no-results-text="По заданному запросу ничего не найдено"
              :headers="headers"
              :items="promocodes"
              v-model="selected"
              :options.sync="options"
              :footer-props="footerProps"
              :header-props="{sortIcon: 'icon-custom-arrow'}"
              :items-per-page="-1"
              :loading="loading"
              loading-text="Загрузка промокодов... Подождите пожалуйста"
      >
      </v-data-table>
      <!--</v-card>-->
    </v-col>
    <v-dialog
            v-model="promocodeDialog"
            max-width="445"
    >
      <v-card>
        <v-card-title class="headline">
          {{blocked ? 'Заблокировать' : 'Отправить'}} промокод
        </v-card-title>

        <v-card-text>
          <v-autocomplete
                  :items="promocodesInDialog"
                  :item-text="promocode => promocode.code"
                  :item-value="promocode => promocode.id"
                  v-model="currentPromocode"
                  outlined
          ></v-autocomplete>
        </v-card-text>

        <v-card-actions>
          <v-btn
                  :loading="loadingButton"
                  @click="sendPromocode"
          >
            {{blocked ? 'Заблокировать' : 'Начислить'}}
          </v-btn>
          <v-btn
                  outlined
                  @click="promocodeDialog = false"
          >
            Отменить
          </v-btn>


        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
            v-model="snackbar"
            :timeout="timeout"
            :color="snackbarColor"
            right
            top
    >
      {{ snackbarText }}
    </v-snackbar>
  </v-row>
</template>

<script>
    // @ is an alias to /src

    import PromocodeService from '../../../api/PromocodeService'
    import UserService from "../../../api/UserService";

    export default {
        name: 'PromocodeUserIndex',
        props: {
          value: Object,
        },
        components: {},
      data() {
        return {
          loading: false,
          promocodeDialog: false,
          blocked: false,
          loadingButton: false,
          snackbar: false,
          timeout: 2000,
          snackbarText: '',
          snackbarColor: '',
          user: this.value,
          search: '',
          promocodesInDialog: [],
          currentPromocode: null,
          selected: [],
          promocodes: [],
          options: {},
          footerProps: {
            itemsPerPageText: 'Промокодов на страницу',
            pageText: '{0}-{1} из {2}',
            itemsPerPageAllText: 'Все',
            itemsPerPageOptions: [-1]
          },
          total: 0,
          headers: [
            {
              text: 'Создан',
              value: 'created_at'
            },
            {
              text: 'Промокод',
              value: 'code',
            },
            {
              text: 'Описание',
              value: 'name',
            },
            {
              text: 'Статус',
              value: 'status',
            },
          ],
        }
      },
        mounted() {
          this.getDataFromApi()

          let params = {
            available: true
          }
          PromocodeService.list(params).then(response => {
            this.promocodesInDialog = response.data.data
          })
        },
        watch: {
            options: {
                handler() {
                    this.getDataFromApi()
                },
                deep: true,
            },
        },
        methods: {
          sendPromocode(){
            if(!this.currentPromocode){
              this.snackbar = true;
              this.snackbarText = 'Заполните поля';
              this.snackbarColor = 'error';
            }
            this.loadingButton = true;

            let ids = []
            ids.push(this.user.id)

            let params = {
              ids: ids,
              promocode_id: this.currentPromocode,
              blocked: this.blocked,
            }

            UserService.sendPromocode(params).then(response => {
              this.loadingButton = false;
              this.promocodeDialog= false;
              if (response.data.err) {
                this.snackbar = true;
                this.snackbarText = response.data.err;
                this.snackbarColor = 'error';
              } else {
                this.snackbar = true;
                this.snackbarText = 'Промокод отправлен';
                this.snackbarColor = 'success';
              }
              this.getDataFromApi()
            })
          },
            getDataFromApi() {
                this.loading = true
              this.selected = [];

                PromocodeService.listByUser(this.user.id)
                    .then(response => {
                        this.promocodes = Array.from(Object.values(response.data))
                        this.loading = false
                    })
            },
        }
    }
</script>

<style>
  .changed-row{
    background-color: #FFEEEC;
  }
</style>

<style lang="scss" scoped>
  .v-btn--fab.v-size--x-small {
    width: 20px;
    height: 20px;

    .mdi::before {
      font-size: 12px;
    }
  }
  span.v-btn{
    border-color: currentColor!important;
  }

  .filter-popup {
    position: absolute;
    width: 250px;
    z-index: 5;

    &:hover {
      cursor: auto;
    }



    &.v-card--link:focus::before {
      opacity: 0;
    }
  }
</style>
